import { QuizProvider } from '@packages/shared/core/quiz/context';
import SimpleRegistrationSteps from '@packages/shared/simple-simple-registration/components/quiz/SimpleRegistrationSteps';
import { quizResources } from './resources';

const SimpleRegistrationQuiz = ({ pageId }: { pageId: string }) => (
  <QuizProvider data={quizResources}>
    <SimpleRegistrationSteps pageId={pageId} />
  </QuizProvider>
);

export default SimpleRegistrationQuiz;
